import angular from 'angular';

export default angular.module('components.serials', [])
    .component('serialsSimple', {
        template: require('./serialsSimple.pug')(),
        controller: ['$state', 'SerialsConfig', function($state, SerialsConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.catalogid = SerialsConfig.catalogid;
                ctrl.sortKeysList= SerialsConfig.sortKeysList;
                ctrl.facetsList= SerialsConfig.facetsList;
                ctrl.rsnList= SerialsConfig.rsnList;
            };
        }]
    })
    .component('serialsAdvanced', {
        template: require('./serialsAdvanced.pug')(),
        controller: ['SerialsConfig', function(SerialsConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.catalogid = SerialsConfig.catalogid;
                ctrl.sortKeysList= SerialsConfig.sortKeysList;
                ctrl.facetsList= SerialsConfig.facetsList;
                ctrl.rsnList= SerialsConfig.rsnList;
                ctrl.attributesList = SerialsConfig.attributesList;
            };
        }]
    })
    .component('serialsBrowsing', {
        bindings: {
            start: '<',
            pos: '<'
        },
        template: require('./serialsBrowsing.pug')(),
        controller: [ 'SerialsConfig', 'ZebraService', '$state', function(SerialsConfig, ZebraService, $state) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.catalogid = SerialsConfig.catalogid;
                ctrl.index = SerialsConfig.index;
                ctrl.maximumTerms = SerialsConfig.maximumTerms;
                ctrl.callScan(ctrl.start, ctrl.pos);
            };

            ctrl.callScan =  function(term, pos) {
                if (term) {
                    ctrl.loading = true;
                    scan(ctrl.catalogid, ctrl.index, term, pos, ctrl.maximumTerms,  function(err, response) {
                        ctrl.loading = false;
                        if (err) {
                            ctrl.error = err.message || err;
                        }
                        ctrl.response = response;
                        if (ctrl.response && ctrl.response.terms) {
                            var size = ctrl.response.terms.length;
                            if (size > 0) {
                                ctrl.next_term = ctrl.response.terms[size-1].value;
                                ctrl.next_pos = 1;
                            }
                            if (size > 1) {
                                ctrl.prev_term = ctrl.response.terms[0].value;
                                ctrl.prev_pos = size;
                            }
                        }
                    });

                }
            };

            ////////

            function scan(id, index, term, pos, max, done) {
                var params = {};
                params.id = id;
                params.operation = 'scan';
                params.scanClause = index + '="^' + term.replace(/\\"/g, '\\"') +'"';
                    params.maximumTerms = max;
                    params.responsePosition = pos;
                    console.log(params);
                    ZebraService.get(params).$promise.then(function(response) {
                        done(null, response);
                    }, function(err) {
                        done(err, null);
                    });
            }
        }]
    })
    .component('serialsSearch', {
        bindings: {
            title: '<'
        },
        template: require('./serialsSearch.pug')(),
        controller: ['$state', 'ZebraService', 'SerialsConfig', function($state, ZebraService, SerialsConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.catalogid = SerialsConfig.catalogid;
                ctrl.sortKeysList= SerialsConfig.sortKeysList;
                ctrl.index = SerialsConfig.index;
                ctrl.schemasList = SerialsConfig.schemasList;
                ctrl.callSearch();
            };

            ctrl.callSearch = function() {
                var query = 'cuba.recordLinking=1 and ' + ctrl.index + '="' + ctrl.title.replace(/"/g, '\\"') + '"';
                var schema = ctrl.schemasList[0].value;

                ctrl.loading = true;
                search(ctrl.catalogid, query, schema, function(err, response) {
                    ctrl.loading = false;
                    if (err) {
                        ctrl.error = err.message || err;
                    }
                    ctrl.response = response;
                });
            };

            ////////

            function search(id, q, schema, done) {
                var params = {};
                params.id = id;
                params.operation = 'search';
                params.query = q;
                params.recordSchema = schema;
                console.log(params);
                ZebraService.get(params).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }

        }]
    })
    .component('serialsDocument', {
        bindings: {
            id: '<'
        },
        template: require('./serialsDocument.pug')(),
        controller: ['$state', 'ZebraService', 'SerialsConfig', function($state, ZebraService, SerialsConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.catalogid = SerialsConfig.catalogid;
                ctrl.schemasList = SerialsConfig.schemasList;
                ctrl.callSearch();
            };

            ctrl.callSearch = function() {
                var id =  ctrl.id.replace(/"/g, '\\"').replace(/\\/g, '\\\\');
                var query = 'rec.id="' + id + '"';
                var schema = ctrl.schemasList[0].value;

                ctrl.loading = true;
                search(ctrl.catalogid, query, schema, function(err, response) {
                    ctrl.loading = false;
                    if (err) {
                        ctrl.error = err.message || err;
                    }
                    ctrl.response = response;
                });
            };

            ////////

            function search(id, q, schema, done) {
                var params = {};
                params.id = id;
                params.operation = 'search';
                params.query = q;
                params.recordSchema = schema;
                console.log(params);
                ZebraService.get(params).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }

        }]
    })
    .component('serialsRelatedInstances', {
        bindings: {
            id: '<'
        },
        template: require('./serialsRelatedInstances.pug')(),
        controller: ['SerialsConfig', function(SerialsConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.catalogid = SerialsConfig.catalogid;
                ctrl.sortKeysList= SerialsConfig.sortKeysList;
                ctrl.facetsList = SerialsConfig.facetsList;
                ctrl.rsnList = SerialsConfig.rsnList;
            };
        }]
    })
    .value('SerialsConfig', {
        catalogid: 7,
        maximumTerms: 50,
        index: "cuba.title",
        schemasList: [
            {name: __("BIB v1.1"), value: "bibv1.1"}, 
            {name: __("BIB"), value: "bib"}, 
            {name: __("Portal"), value: "portal"}, 
            {name: __("MARC"), value: "marcxml"} 
        ],
        sortKeysList: [
            {name: __('Publication date (new)'), value:'cql.sortByDateDescending=0'},
            {name: __('Publication date (old)'), value:'cql.sortByDateAscending=0'},
            {name: __('Relevant'), value:''},
            //{name: 'РелевRecord key ue:'cql.sortByRecordLinkingAscending=0'},
            {name: __('Author (A-Z)'), value:'cql.sortByAuthorAscending=0', glyphicon: 'glyphicon glyphicon-sort-by-alphabe'},
            {name: __('Author (Z-A)'), value:'cql.sortByAuthorDescending=0', grlyphicon: 'glyphicon glyphicon-sort-by-alphabet-alt'},
            {name: __('Record key (ascending)'), value:'cql.sortByLocalNumberAscending=0'},
            {name: __('Record key (descending)'), value:'cql.sortByLocalNumberDescending=0'},
        ],
        facetsList: [
            //{name: __("Author"), index: 'dc.creator', schema: 'zebra::facet::author:p:10'},
            //{name: __("Subject heading"), index: 'dc.subject', schema: 'zebra::facet::subject-heading:p:10'},
            //{name: __("Publisher"), index:'dc.publisher', schema: 'zebra::facet::publisher:p:10'},
            //{name: __("Publication date"), index: 'dc.date', schema: 'zebra::facet::date-of-publication:w:10'},
            //{name: __("Inventory"), index: 'cuba.999b', schema: 'zebra::facet::cuba-999-b:w:10'}
        ],
        rsnList: [
            {name: __("Year of publication"), index: 'dc.date', query: 'cuba.dateNarrow=2021', schema: 'marcxml'}
        ],
        attributesList: [
            {name: __('Title'), value: 'dc.title'},
            //{name: __('Author'), value: 'dc.creator'},
            //{name: __('Discipline'), value: 'dc.subject'},
            //{name: __('ISBN'), value: 'bath.isbn'},
            {name: __('ISSN'), value: 'bath.issn'},
            {name: __('Year of publication'), value: 'dc.date'},
            {name: __('Geographic location'), value: 'cuba.placePublication'},
            {name: __('Publisher'), value: 'dc.publisher'},
            {name: __('All fields'), value: 'cql.serverChoice'},
            //{name: __('Universal Decimal Classification'), value: 'cuba.classificationUDC'},
            //{name: __('Library-Bibliographical Classification'), value: 'cuba.classificationLocal'},
            //{name: __('OKSVNK Classification'), value: 'cuba.classificationLocal'},
            {name: __('Record insertion date'), value: 'cuba.dateAddedToDB'},
            {name: __('Record identifier'), value: 'rec.id'},
            //{name: __('Все записи?'), value: 'cql.allRecords'},
            //{name: __('Exhibition name'), value: 'cql.cuba.exhibition'},
            //{name: __('Exhibition identifier'), value: 'cql.cuba.exhibitionCode'},
            //{name: __('Discipline name'), value: 'cql.cuba.discipline'}
        ]
    })
    .name; 
